import React, { useEffect, useState } from 'react'
import { Switch } from 'components/ds/Choice'
import { Toast } from 'components/shared/Toaster'
import strings from 'strings'
import AuthService from 'tools/AuthService'
import { getMonitoringAlertsPaused, setMonitoringAlertsPaused } from 'actions/monitoring'

const S = strings.PROFILE_NOTIFICATIONS

// Profile > Notifications: one switch that pauses or resumes all of the user's monitoring alerts (email and
// in-app). Their per-business "Notify me" choices are kept, so turning it back on restores the same alerts.
const MonitoringAlertsSetting = () => {
    const [on, setOn] = useState(null) // null while loading
    const [saving, setSaving] = useState(false)
    // The bell (in-app alerts) only exists for clients with the activity dashboard; otherwise mention email only.
    const inAppAvailable = !!AuthService.getClientFeatures().activityDashboardEnabled

    useEffect(() => {
        getMonitoringAlertsPaused()()
            .then((res) => setOn(!res?.paused))
            .catch(() => setOn(true))
    }, [])

    const change = (next) => {
        setOn(next)
        setSaving(true)
        setMonitoringAlertsPaused(!next)()
            .then(() => Toast({ type: 'success', message: next ? S.RESUMED : S.PAUSED }))
            .catch(() => setOn(!next)) // the request helper already shows the error
            .finally(() => setSaving(false))
    }

    return (
        <div className='text-left'>
            <h5 style={{ fontWeight: 700 }}>{S.TITLE}</h5>
            <Switch
                label={S.MONITORING_ALERTS}
                checked={!!on}
                disabled={on === null || saving}
                onChange={(e) => change(e.target.checked)}
            />
            <div style={{ fontSize: 13, color: '#5b6b68', marginTop: 8, maxWidth: 560, lineHeight: 1.5 }}>
                {on === false ? S.OFF_HINT : (inAppAvailable ? S.ON_HINT : S.ON_HINT_EMAIL_ONLY)}
            </div>
        </div>
    )
}

export default MonitoringAlertsSetting
